import { FacebookPageDto, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeLeading } from 'redux-saga/effects';

import { fromDto as fromFacebookPageDto } from '../../../../models/adapters/FacebookPageAdapter';
import { waitBeforeFetch } from '../../../../utils/FetchState';
import {
  facebookPageFetched,
  facebookPageFetchFailed,
  FacebookPageFetchResponsePayload,
  fetchFacebookPage,
  FetchFacebookPagePayload,
} from '../../../actions/setting/facebook/fetchFacebookPage';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function createFacebookPageFetchResponseAction(
  response: { facebookPage: FacebookPageDto; error: string },
  placeUuid: string
): Action<FacebookPageFetchResponsePayload> {
  const { facebookPage: facebookPageDto, error } = response;
  const timestamp = moment();
  if (!error) {
    const facebookPage = fromFacebookPageDto(facebookPageDto);
    return facebookPageFetched({
      facebookPage,
      placeUuid,
      timestamp,
    });
  }
  return facebookPageFetchFailed({ placeUuid, timestamp });
}

function* fetchFacebookPageSaga({ payload }: Action<FetchFacebookPagePayload>) {
  const token = yield getAuthenticationToken();
  const { fetchState, placeUuid } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getFacebookPage, token, { placeUuid });
  const action = createFacebookPageFetchResponseAction(response, placeUuid);
  yield put(action);
}

export default function* watchFetchFacebookPageSaga() {
  yield takeLeading(fetchFacebookPage, fetchFacebookPageSaga);
}
